class Card {
    constructor(id, name, active, comment, ws) {
        this.id = id;
        this.name = name;
        this.active = active;
        this.activeBool = active === "S";
        this.activeTable = active === "S" ? '✔️' : "";
        this.comment = comment;
        this.ws = ws;
    }

    static fromJson({
        tarjId,
        tarjeta,
        numTarj,
        habil,
        comentario,
        ws
    }) {
        const finalCardName = tarjeta || numTarj ;
        return new Card(
            tarjId,
            finalCardName,
            habil,
            comentario,
            ws
        );
    }
}

export default Card;
